module.exports = __webpack_public_path__ + "img/medalla_gran_oro_2020.bad6b987.png";